import {
    FETCH_CLOUDFRONT_REQUEST,
    FETCH_CLOUDFRONT_SUCCESS,
    FETCH_CLOUDFRONT_FAILED
} from './mutation-type'
function distributionConvertId (resourceId) {
    const convertId = resourceId.split('distribution/')
    if (convertId.length > 1) {
        return convertId[1]
    } else {
        return convertId[0]
    }
}
const mutations = {
    [FETCH_CLOUDFRONT_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_CLOUDFRONT_SUCCESS]: (state, { data, status }) => {
        state.status = status
        state.distributionDates = data.distributionDates || []
        state.typeValues = data.cloudFrontUsageTypes || []
        if (data.distributionLists?.length) {
            state.distributions = data.distributionLists.map(item => {
                return {
                    distributionId: distributionConvertId(item.resourceId),
                    ...item
                }
            })
        } else {
            state.distributions = []
        }
    },
    [FETCH_CLOUDFRONT_FAILED]: (state, error) => {
        state.distributionDates = []
        state.typeValues = []
        state.distributions = []
        state.status = 'error'
    }
}

export default mutations
